import { TcSettingsView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

/** Settings · AI Brain › Treatment Coordinator (amendment 27 §8). */
export function SettingsTcPage() {
  const navigate = useNavigate();
  return (
    <TcSettingsView
      onOpenCampaigns={() => { void navigate('/treatment-intelligence/campaigns'); }}
      onPreviewPlan={() => { window.open('/p/K7q9Xm2vR4tBw8LpZ3nQ5d?state=plan&staff=1', '_blank'); }}
    />
  );
}
